import { defineMessages } from "locales/defineMessages";

export default defineMessages({
  vi: {
    "sessionDetailPage.status.done": "Đã kết thúc",

    "sessionDetailPage.attendanceStatus.unmarked": "Chưa điểm danh",
    "sessionDetailPage.attendanceStatus.checked_in": "Đã vào",
    "sessionDetailPage.attendanceStatus.checked_out": "Đã ra",
    "sessionDetailPage.attendanceStatus.absent": "Vắng mặt",
    "sessionDetailPage.attendanceStatus.excused_absence": "Vắng có phép",
    "sessionDetailPage.manualStatus.checked_in": "Đã check-in",
    "sessionDetailPage.manualStatus.checked_out": "Đã check-out",

    "sessionDetailPage.attendance.in": "Vào",
    "sessionDetailPage.attendance.out": "Ra",
    "sessionDetailPage.attendance.inAt": "Vào {time}",
    "sessionDetailPage.attendance.outAt": "Ra {time}",
    "sessionDetailPage.attendance.inOutAt": "Vào {inTime} · Ra {outTime}",
    "sessionDetailPage.attendance.failed": "Điểm danh thất bại",
    "sessionDetailPage.attendance.checkinAfterCheckout":
      "Người tham gia đã check-out, không thể chuyển lại trạng thái check-in.",

    "sessionDetailPage.dobMissing": "Chưa cập nhật ngày sinh",
    "sessionDetailPage.unscheduled": "Chưa xếp lịch",
    "sessionDetailPage.noEmail": "Chưa có email",
    "sessionDetailPage.searchPlaceholder": "Tìm theo tên hoặc email",
    "sessionDetailPage.noStudentMatch": "Không tìm thấy học viên phù hợp.",
    "sessionDetailPage.capturedImageAlt": "Ảnh chụp",

    "sessionDetailPage.auditAction.SESSION_CREATED": "Tạo buổi học",
    "sessionDetailPage.auditAction.SESSION_UPDATED": "Cập nhật buổi học",
    "sessionDetailPage.auditAction.SESSION_CANCELLED": "Hủy buổi học",
    "sessionDetailPage.auditAction.SESSION_COMPLETED": "Hoàn thành buổi học",
    "sessionDetailPage.auditAction.SESSION_ACTIVATED": "Bắt đầu buổi học",
    "sessionDetailPage.auditAction.SESSION_PARTICIPANTS_SYNCED":
      "Cập nhật thành phần buổi học",
    "sessionDetailPage.auditEntity.class": "Lớp học",
    "sessionDetailPage.auditEntity.session": "Buổi học",
    "sessionDetailPage.auditEntity.session_participant": "Thành phần buổi học",
    "sessionDetailPage.auditField.start_time": "giờ bắt đầu",
    "sessionDetailPage.auditField.end_time": "giờ kết thúc",
    "sessionDetailPage.auditField.duration_minutes": "thời lượng",
    "sessionDetailPage.auditField.status": "trạng thái",
    "sessionDetailPage.auditField.title": "tiêu đề",
    "sessionDetailPage.auditField.description": "mô tả",
    "sessionDetailPage.auditField.venue_id": "địa điểm",
    "sessionDetailPage.auditField.location": "vị trí",
    "sessionDetailPage.auditField.teacher_ids": "quản lý lớp",
    "sessionDetailPage.auditField.trainer_ids": "huấn luyện viên",
    "sessionDetailPage.auditField.student_ids": "học viên",
    "sessionDetailPage.auditValue.empty": "Không có",

    "sessionDetailPage.capture.title": "Điểm danh",
    "sessionDetailPage.capture.subtitle":
      "Cập nhật trạng thái tham gia buổi học",
    "sessionDetailPage.capture.cameraError":
      "Không thể truy cập camera. Vui lòng kiểm tra quyền truy cập.",
    "sessionDetailPage.capture.locationRequired":
      "Vui lòng bật định vị và đứng gần vị trí buổi học để mở camera.",
    "sessionDetailPage.capture.outOfRange":
      "Bạn đang ngoài phạm vi điểm danh ({distance}m, tối đa 300m).",
    "sessionDetailPage.capture.saveFailed": "Lưu điểm danh thất bại",
    "sessionDetailPage.capture.serverUnreachable":
      "Không thể kết nối máy chủ điểm danh",
    "sessionDetailPage.capture.confirmFailed": "Xác nhận điểm danh thất bại",
    "sessionDetailPage.capture.checkinSuccess":
      "Check-in thành công cho {name}",
    "sessionDetailPage.capture.checkoutSuccess":
      "Check-out thành công cho {name}",
    "sessionDetailPage.capture.chooseType": "Chọn loại điểm danh",
    "sessionDetailPage.capture.distance": "Khoảng cách:",
    "sessionDetailPage.capture.noSessionCoords":
      "Chưa cấu hình tọa độ buổi học",
    "sessionDetailPage.capture.locating": "Đang lấy định vị thiết bị...",
    "sessionDetailPage.capture.locationUnavailable":
      "Không lấy được định vị thiết bị",
    "sessionDetailPage.capture.distanceInRange":
      "{distance}m (trong phạm vi 300m)",
    "sessionDetailPage.capture.distanceOutOfRange":
      "{distance}m (ngoài phạm vi 300m)",
    "sessionDetailPage.capture.checkin": "Check-in",
    "sessionDetailPage.capture.checkout": "Check-out",
    "sessionDetailPage.capture.manual": "Thủ công",
    "sessionDetailPage.capture.willAddToSession": "{name} • Sẽ thêm vào buổi",
    "sessionDetailPage.capture.notInList": "{name} • Không thuộc danh sách",
    "sessionDetailPage.capture.similarity": "Độ tương đồng: {score}%",
    "sessionDetailPage.capture.cameraOffManual":
      "Camera đã tắt ở chế độ thủ công",
    "sessionDetailPage.capture.cameraStarting": "Đang khởi động camera...",
    "sessionDetailPage.capture.recognizing": "Đang nhận diện...",
    "sessionDetailPage.capture.confirming": "Đang xác nhận...",
    "sessionDetailPage.capture.confirmAndAdd":
      "Xác nhận và thêm vào buổi ({action})",
    "sessionDetailPage.capture.confirmAction": "Xác nhận {action}",
    "sessionDetailPage.capture.participants": "Người tham gia",
    "sessionDetailPage.capture.pendingChanges": "{count} thay đổi",
    "sessionDetailPage.capture.noParticipantMatch":
      "Không tìm thấy người tham gia phù hợp.",
    "sessionDetailPage.capture.confirmSaveTitle": "Xác nhận lưu điểm danh",
    "sessionDetailPage.capture.confirmSaveMessage":
      "Bạn có chắc muốn cập nhật trạng thái điểm danh cho {count} người tham gia?",
    "sessionDetailPage.capture.confirmSave": "Xác nhận lưu",

    "sessionDetailPage.auditLoadFailed":
      "Không tải được lịch sử thay đổi buổi học",
    "sessionDetailPage.updateSettingsFailed": "Không thể cập nhật cài đặt",
    "sessionDetailPage.sessionStarted": "Đã bắt đầu buổi học",
    "sessionDetailPage.startFailed": "Không thể bắt đầu buổi học",
    "sessionDetailPage.confirmStartAndAttend":
      "Buổi học đang ở trạng thái Đã lên lịch. Bạn có muốn bắt đầu buổi học và mở điểm danh ngay không?",
    "sessionDetailPage.notFound": "Không tìm thấy buổi học",
    "sessionDetailPage.classLabel": "Lớp: {name}",
    "sessionDetailPage.submitReport": "Gửi báo cáo",
    "sessionDetailPage.editReport": "Sửa báo cáo",
    "sessionDetailPage.startSession": "Bắt đầu buổi học",
    "sessionDetailPage.exportAttendance": "Xuất điểm danh",
    "sessionDetailPage.sessionInfo": "Thông tin buổi học",
    "sessionDetailPage.status": "Trạng thái",
    "sessionDetailPage.outsideCheckin": "Điểm danh ngoài phạm vi",
    "sessionDetailPage.toggleOn": "Đang bật",
    "sessionDetailPage.toggleOff": "Đang tắt",
    "sessionDetailPage.venue": "Địa điểm học",
    "sessionDetailPage.noTeacher": "Chưa chọn quản lý lớp.",
    "sessionDetailPage.noTrainer": "Chưa chọn huấn luyện viên.",
    "sessionDetailPage.allStatuses": "Tất cả trạng thái",
    "sessionDetailPage.attendedCount": "Đã điểm danh: {done}/{total}",
    "sessionDetailPage.takeAttendance": "Điểm danh",
    "sessionDetailPage.noStudents":
      "Chưa có học viên nào được chọn cho buổi này.",
    "sessionDetailPage.dob": "Ngày sinh: {dob}",
    "sessionDetailPage.remainingSessions": "Còn {count} buổi",
    "sessionDetailPage.sessionReport": "Báo cáo buổi học",

    "sessionDetailPage.audit.title": "Lịch sử thay đổi buổi học",
    "sessionDetailPage.audit.hide": "Ẩn",
    "sessionDetailPage.audit.show": "Xem",
    "sessionDetailPage.audit.loading": "Đang tải lịch sử thay đổi...",
    "sessionDetailPage.audit.emailFilter": "Lọc theo email...",
    "sessionDetailPage.audit.allActions": "Tất cả loại thao tác",
    "sessionDetailPage.audit.allSessions": "Tất cả buổi học",
    "sessionDetailPage.audit.empty":
      "Chưa có bản ghi thay đổi cho buổi học này.",
    "sessionDetailPage.audit.noMatch": "Không có bản ghi phù hợp bộ lọc.",
    "sessionDetailPage.audit.system": "Hệ thống",
    "sessionDetailPage.audit.collapse": "Thu gọn",
    "sessionDetailPage.audit.expand": "Mở rộng",
    "sessionDetailPage.audit.noFieldChanges": "Không có thay đổi chi tiết.",
  },
  en: {
    "sessionDetailPage.status.done": "Completed",

    "sessionDetailPage.attendanceStatus.unmarked": "Not marked",
    "sessionDetailPage.attendanceStatus.checked_in": "Checked in",
    "sessionDetailPage.attendanceStatus.checked_out": "Checked out",
    "sessionDetailPage.attendanceStatus.absent": "Absent",
    "sessionDetailPage.attendanceStatus.excused_absence": "Excused absence",
    "sessionDetailPage.manualStatus.checked_in": "Checked in",
    "sessionDetailPage.manualStatus.checked_out": "Checked out",

    "sessionDetailPage.attendance.in": "In",
    "sessionDetailPage.attendance.out": "Out",
    "sessionDetailPage.attendance.inAt": "In {time}",
    "sessionDetailPage.attendance.outAt": "Out {time}",
    "sessionDetailPage.attendance.inOutAt": "In {inTime} · Out {outTime}",
    "sessionDetailPage.attendance.failed": "Attendance failed",
    "sessionDetailPage.attendance.checkinAfterCheckout":
      "This participant has already checked out and can't be set back to checked in.",

    "sessionDetailPage.dobMissing": "Date of birth not set",
    "sessionDetailPage.unscheduled": "Not scheduled",
    "sessionDetailPage.noEmail": "No email",
    "sessionDetailPage.searchPlaceholder": "Search by name or email",
    "sessionDetailPage.noStudentMatch": "No matching students.",
    "sessionDetailPage.capturedImageAlt": "Captured photo",

    "sessionDetailPage.auditAction.SESSION_CREATED": "Session created",
    "sessionDetailPage.auditAction.SESSION_UPDATED": "Session updated",
    "sessionDetailPage.auditAction.SESSION_CANCELLED": "Session cancelled",
    "sessionDetailPage.auditAction.SESSION_COMPLETED": "Session completed",
    "sessionDetailPage.auditAction.SESSION_ACTIVATED": "Session started",
    "sessionDetailPage.auditAction.SESSION_PARTICIPANTS_SYNCED":
      "Session participants updated",
    "sessionDetailPage.auditEntity.class": "Class",
    "sessionDetailPage.auditEntity.session": "Session",
    "sessionDetailPage.auditEntity.session_participant": "Session participants",
    "sessionDetailPage.auditField.start_time": "start time",
    "sessionDetailPage.auditField.end_time": "end time",
    "sessionDetailPage.auditField.duration_minutes": "duration",
    "sessionDetailPage.auditField.status": "status",
    "sessionDetailPage.auditField.title": "title",
    "sessionDetailPage.auditField.description": "description",
    "sessionDetailPage.auditField.venue_id": "venue",
    "sessionDetailPage.auditField.location": "location",
    "sessionDetailPage.auditField.teacher_ids": "class managers",
    "sessionDetailPage.auditField.trainer_ids": "trainers",
    "sessionDetailPage.auditField.student_ids": "students",
    "sessionDetailPage.auditValue.empty": "None",

    "sessionDetailPage.capture.title": "Attendance",
    "sessionDetailPage.capture.subtitle": "Update session participation status",
    "sessionDetailPage.capture.cameraError":
      "Can't access the camera. Please check camera permissions.",
    "sessionDetailPage.capture.locationRequired":
      "Turn on location and stay near the session venue to open the camera.",
    "sessionDetailPage.capture.outOfRange":
      "You're outside the check-in range ({distance}m, max 300m).",
    "sessionDetailPage.capture.saveFailed": "Failed to save attendance",
    "sessionDetailPage.capture.serverUnreachable":
      "Can't connect to the attendance server",
    "sessionDetailPage.capture.confirmFailed": "Failed to confirm attendance",
    "sessionDetailPage.capture.checkinSuccess": "Checked in {name}",
    "sessionDetailPage.capture.checkoutSuccess": "Checked out {name}",
    "sessionDetailPage.capture.chooseType": "Choose attendance type",
    "sessionDetailPage.capture.distance": "Distance:",
    "sessionDetailPage.capture.noSessionCoords":
      "Session coordinates not configured",
    "sessionDetailPage.capture.locating": "Getting device location...",
    "sessionDetailPage.capture.locationUnavailable":
      "Couldn't get device location",
    "sessionDetailPage.capture.distanceInRange": "{distance}m (within 300m)",
    "sessionDetailPage.capture.distanceOutOfRange":
      "{distance}m (outside 300m)",
    "sessionDetailPage.capture.checkin": "Check-in",
    "sessionDetailPage.capture.checkout": "Check-out",
    "sessionDetailPage.capture.manual": "Manual",
    "sessionDetailPage.capture.willAddToSession":
      "{name} • Will be added to the session",
    "sessionDetailPage.capture.notInList": "{name} • Not on the list",
    "sessionDetailPage.capture.similarity": "Similarity: {score}%",
    "sessionDetailPage.capture.cameraOffManual": "Camera is off in manual mode",
    "sessionDetailPage.capture.cameraStarting": "Starting camera...",
    "sessionDetailPage.capture.recognizing": "Recognizing...",
    "sessionDetailPage.capture.confirming": "Confirming...",
    "sessionDetailPage.capture.confirmAndAdd":
      "Confirm and add to session ({action})",
    "sessionDetailPage.capture.confirmAction": "Confirm {action}",
    "sessionDetailPage.capture.participants": "Participants",
    "sessionDetailPage.capture.pendingChanges": "{count} changes",
    "sessionDetailPage.capture.noParticipantMatch": "No matching participants.",
    "sessionDetailPage.capture.confirmSaveTitle": "Confirm attendance update",
    "sessionDetailPage.capture.confirmSaveMessage":
      "Are you sure you want to update attendance for {count} participants?",
    "sessionDetailPage.capture.confirmSave": "Confirm and save",

    "sessionDetailPage.auditLoadFailed":
      "Couldn't load the session change history",
    "sessionDetailPage.updateSettingsFailed": "Couldn't update the setting",
    "sessionDetailPage.sessionStarted": "Session started",
    "sessionDetailPage.startFailed": "Couldn't start the session",
    "sessionDetailPage.confirmStartAndAttend":
      "This session is still scheduled. Start it now and open attendance?",
    "sessionDetailPage.notFound": "Session not found",
    "sessionDetailPage.classLabel": "Class: {name}",
    "sessionDetailPage.submitReport": "Submit report",
    "sessionDetailPage.editReport": "Edit report",
    "sessionDetailPage.startSession": "Start session",
    "sessionDetailPage.exportAttendance": "Export attendance",
    "sessionDetailPage.sessionInfo": "Session information",
    "sessionDetailPage.status": "Status",
    "sessionDetailPage.outsideCheckin": "Out-of-range check-in",
    "sessionDetailPage.toggleOn": "On",
    "sessionDetailPage.toggleOff": "Off",
    "sessionDetailPage.venue": "Venue",
    "sessionDetailPage.noTeacher": "No class manager assigned.",
    "sessionDetailPage.noTrainer": "No trainer assigned.",
    "sessionDetailPage.allStatuses": "All statuses",
    "sessionDetailPage.attendedCount": "Checked in: {done}/{total}",
    "sessionDetailPage.takeAttendance": "Take attendance",
    "sessionDetailPage.noStudents":
      "No students have been added to this session.",
    "sessionDetailPage.dob": "Date of birth: {dob}",
    "sessionDetailPage.remainingSessions": "{count} sessions left",
    "sessionDetailPage.sessionReport": "Session report",

    "sessionDetailPage.audit.title": "Session change history",
    "sessionDetailPage.audit.hide": "Hide",
    "sessionDetailPage.audit.show": "Show",
    "sessionDetailPage.audit.loading": "Loading change history...",
    "sessionDetailPage.audit.emailFilter": "Filter by email...",
    "sessionDetailPage.audit.allActions": "All action types",
    "sessionDetailPage.audit.allSessions": "All sessions",
    "sessionDetailPage.audit.empty":
      "No changes recorded for this session yet.",
    "sessionDetailPage.audit.noMatch": "No records match the filters.",
    "sessionDetailPage.audit.system": "System",
    "sessionDetailPage.audit.collapse": "Collapse",
    "sessionDetailPage.audit.expand": "Expand",
    "sessionDetailPage.audit.noFieldChanges": "No detailed changes.",
  },
});
